/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    BDOperation,
    BDOperationFromJSON,
    BDOperationToJSON,
    EntityType,
    EntityTypeFromJSON,
    EntityTypeToJSON,
} from '../models';

export interface UpdateHistoryV2HistoryGetRequest {
    id?: string;
    type?: EntityType;
}

/**
 * no description
 */
export class UpdateHistoryV2Api extends runtime.BaseAPI {

    /**
     */
    async updateHistoryV2HistoryGetRaw(requestParameters: UpdateHistoryV2HistoryGetRequest): Promise<runtime.ApiResponse<Array<BDOperation>>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.id !== undefined) {
            queryParameters['id'] = requestParameters.id;
        }

        if (requestParameters.type !== undefined) {
            queryParameters['type'] = requestParameters.type;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/UpdateHistoryV2/history`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(BDOperationFromJSON));
    }

    /**
     */
    async updateHistoryV2HistoryGet(requestParameters: UpdateHistoryV2HistoryGetRequest): Promise<Array<BDOperation>> {
        const response = await this.updateHistoryV2HistoryGetRaw(requestParameters);
        return await response.value();
    }

}
